import dayjs from 'dayjs';
import moment from 'moment';
import dateTimeConstants from 'constants/datetime';

const { MONTH_SLASH_FORMAT } = dateTimeConstants;

const DISPLAY_TIME_FORMAT = 'DD/MM/YYYY';

const parseTimeFromString = (
  date: string,
  format = DISPLAY_TIME_FORMAT
): moment.Moment => {
  return moment(date, format);
};

const getMonthYearNow = () => {
  return dayjs().format(MONTH_SLASH_FORMAT);
};

const getFirstDayOfMonth = () => {
  return moment().startOf('month');
};

const getCurrentDay = () => {
  return moment();
};

export default {
  parseTimeFromString,
  TIME_FORMAT: DISPLAY_TIME_FORMAT,
  getMonthYearNow,
  getFirstDayOfMonth,
  getCurrentDay,
};
